import { Box, MenuItem, Tab, Tabs, styled } from "@mui/material";

export const FormInfo = styled(Box)(() => ({
  backgroundColor: '#fff7cb',
  margin: '2rem auto 0',
  padding: '1.5rem',
}));

export const SubTabsWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: '#F2F2F2',
  height: '8vh',
  display: 'flex',
  alignItems: 'center',
  '& .container1': {
    justifyContent: 'space-between',
    marginBlock: theme.spacing(4),
    alignItems: 'center',
    display: 'flex',
  },
}));

export const MainTabs = styled(Tabs)(() => ({
  marginInline: 'auto',
}));

export const MainTab = styled(Tab)(() => ({
  '&.MuiTab-root': {
    textTransform: 'none',
    paddingInline: '1rem',
    color: '#1F4A7C',
    outline: 'none',
  },
  '&.Mui-selected': {
    backgroundColor: '#1F4A7C',
    color: 'white',
  },
}));

export const SubTabs = styled(Tabs)(() => ({
  '&.Mui-selected': {
    backgroundColor: '#5CB85C',
    color: 'white',
  },
}));

export const SubTab = styled(Tab)(() => ({
  '&.MuiTab-root': {
    textTransform: 'none',
    paddingInline: '1rem',
    outline: 'none',
    fontSize: '1.25rem',
    fontWeight: '400'
  },
  '&.Mui-selected': {
    // backgroundColor: '#5CB85C',
    color: '#1F4A7C',
    borderBottom: '4px solid #1F4A7C',
    fontSize: '1.25rem',
    fontWeight: '600'
  },
}));

export const MandatoryInfo = styled(Box)(() => ({
  lineHeight: 1,
  fontSize: 14,
  color: 'red',
  '& span': {
    display: 'inline-block',
    translate: '0 4px',
    fontSize: 18,
  }
}));
export const InfoBox = styled(Box)(() => ({
  lineHeight: 1.5,
  fontSize: '16px',
  color: '#1F4A7C',  // Change color as needed
  padding: '8px 16px',
  backgroundColor: '#f0f4fa',
  borderRadius: '1px',
  fontWeight: '600',
  marginLeft: '30px',
  '& span': {
    display: 'inline-block',
    translate: '0 4px',
    fontSize: 18,
  },
}));

export const StyledMenuItem = styled(MenuItem)(() => ({
  '&.MuiMenuItem-root': {
    padding: '0.25rem 0.75rem',
    display: 'block',
  },
}));

export const accordionSummaryStyles = {
  backgroundColor: 'rgb(230, 239, 248)',
  height: '1rem',
  minHeight: '48px',
  '&.Mui-expanded': {
    backgroundColor: 'rgb(230, 239, 248)', // Override the background for expanded state
    minHeight: '48px', // Ensure minHeight is applied in expanded state
    height: '1rem',    // Apply the custom height in expanded state as well
  },
};
